import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_INGREDIENT,
  EXPAND_INGREDIENT_MAIN_TREE_KEYS,
  EXPAND_INGREDIENT_SUPPORTING_TREE_KEYS,
  FETCH_INGREDIENTS,
  MOVE_INGREDIENTS,
  RENAME_INGREDIENT,
  RESET_INGREDIENT_TREE,
  SET_DATA_FOR_RENAMING_INGREDIENT,
} from '../action-types'

export const cleanupFetchIngredients = createAction(FETCH_INGREDIENTS.CLEANUP)
export const addIngredientNode = createPayloadAction(ADD_INGREDIENT)
export const renameIngredientNode = createPayloadAction(RENAME_INGREDIENT)
export const resetIngredientTree = createAction(RESET_INGREDIENT_TREE)
export const moveIngredients = createPayloadAction(MOVE_INGREDIENTS)

export const setDataForRenamingIngredient = createPayloadAction(
  SET_DATA_FOR_RENAMING_INGREDIENT,
)

export const expandIngredientMainTreeKeys = createPayloadAction(
  EXPAND_INGREDIENT_MAIN_TREE_KEYS,
)

export const expandIngredientSupportingTreeKeys = createPayloadAction(
  EXPAND_INGREDIENT_SUPPORTING_TREE_KEYS,
)
